module.exports = __webpack_public_path__ + "static/img/t2-2-1.4117985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t2-2-1.png
// module id = ul2n
// module chunks = 1